import {
    SET_EMAIL_ADDRESS
} from '../constants/actionTypes'


export const setEmailAddress = email => ({
    type: SET_EMAIL_ADDRESS,
    email
})
